export const COUNT_LIMIT = {
  STORY_NAME: 40,
  STORY_DESCRIPTION: 150,
  TAG: 10,
  CHARACTER_NAME: 15,
  CHARACTER_STATUS: 200,
  EPISODE_NAME: 40,
  NARRATION_TEXT: 10000,
  POST_CONTENT: 500,
  DIALOGUE: 10000,
  COMMENT: 500,
  SUGGEST_CONTENT_LENGTH: 1000,
  MAX_LIMIT: 10000000,
  COMMUNITY_COMMENT: 1000,
  BUBBLE_CHAT_TAG: 5,
  BUBBLE_CHAT_LIST_LIMIT: 24,
  BUBBLE_CHAT_ASSET_COMMENT: 1000,
  CHARACTER_INPUT: {
    NAME: 25,
    INTRODUCTION: 500,
    TAG: 5,
    JOB: 20,
    PERSONALITY: 100,
    SPEAKING_STYLE: 100,
    FAVORITES: 100,
    OTHER_DETAILS: 1000,
    FIRST_MESSAGES: 500,
    TRIGGER_IMAGES: {
      MIN_UNLOCK_PRICE: 100,
      MAX_UNLOCK_PRICE: 100_000_000,
    },
  },
  UNIVERSE_INPUT: {
    NAME: 25,
    INTRODUCTION: 500,
    TAG: 5,
    RELATIONSHIPS: 1000,
    OTHER_DETAILS: 2000,
    WORD_BOOKS_TITLE: 25,
    WORD_BOOKS: 10000,
  },
  SCENE_INPUT: {
    NAME: 25,
    TAG: 5,
    PLACE: 100,
    TIME: 100,
    OTHER_DETAILS: 1000,
  },
  CHAT_EDIT_USER_MESSAGE_INPUT: 500,
  CHAT_EDIT_CHARACTER_MESSAGE_INPUT: 2000,
  PASSWORD: {
    MIN: 8,
    MAX: 25,
  },
  SEARCH_VALUE_LENGTH_LIMIT: 40,
};
